"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var change_log_service_1 = require("./change-log.service");
var router_1 = require("@angular/router");
var operators_1 = require("rxjs/operators");
require("./change-view.component.scss");
var lodash_1 = require("lodash");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var ChangeViewComponent = /** @class */ (function () {
    function ChangeViewComponent(_activatedRoute, _authentication, _currentLanguageProvider, _changeLogService) {
        this._activatedRoute = _activatedRoute;
        this._authentication = _authentication;
        this._currentLanguageProvider = _currentLanguageProvider;
        this._changeLogService = _changeLogService;
        this._isCreateVersion = false;
    }
    ChangeViewComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.load$ = this._activatedRoute.params.pipe(operators_1.tap(function (params) {
            _this._category = params['category'];
            _this._instanceId = Number(params['instanceId']);
            _this._userId = Number(params['userId']);
            if (lodash_1.isNil(params['createVersion'])) {
                _this._firstVersionId = params['firstVersionId'];
                _this._secondVersionId = params['secondVersionId'];
                _this._isCreateVersion = false;
            }
            else {
                _this._createVersion = params['createVersion'];
                _this._isCreateVersion = true;
            }
        }), operators_1.switchMap(function () { return _this._currentLanguageProvider.getCurrentLanguage(); }), operators_1.tap(function (lang) {
            _this._currentLanguageId = lang.getId();
        }), operators_1.switchMap(function () { return !_this._isCreateVersion ? _this._changeLogService.getDiffView(_this._category, _this._instanceId, _this._userId, _this._firstVersionId, _this._secondVersionId, _this._currentLanguageId)
            : _this._changeLogService.getDiffView(_this._category, _this._instanceId, _this._userId, _this._createVersion, _this._createVersion, _this._currentLanguageId); }), operators_1.tap(function (groups) {
            _this._groups = groups;
        }));
    };
    ChangeViewComponent.prototype.rowInPath = function (group, rowIndex) {
        return lodash_1.findLastIndex(group.rows, function (row) { return !row.equal; }) > rowIndex;
    };
    Object.defineProperty(ChangeViewComponent.prototype, "currentLanguageId", {
        get: function () {
            return this._currentLanguageId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChangeViewComponent.prototype, "groups", {
        get: function () {
            return this._groups;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChangeViewComponent.prototype, "isCreateVersion", {
        get: function () {
            return this._isCreateVersion;
        },
        enumerable: true,
        configurable: true
    });
    ChangeViewComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'change-view',
            template: require('./change-view.component.html'),
            providers: [change_log_service_1.ChangeLogService]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute,
            idm_authentication_client_js_1.AuthenticationService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            change_log_service_1.ChangeLogService])
    ], ChangeViewComponent);
    return ChangeViewComponent;
}());
exports.ChangeViewComponent = ChangeViewComponent;
//# sourceMappingURL=change-view.component.js.map